window.addEventListener('resize', () => {

    // if(window.innerWidth !== width) {
    //     console.log('width has changed');
    // }

    // if(window.innerHeight !== height) {
    //     // console.log('height has changed');
    // }

    if((window.innerWidth != width) || (window.innerHeight != height)) {
        // console.log('inside if');
        if (typeof hero != "undefined" && hero != null) {
            heroSize();
        }
    }

});